import { Breadcrumb, Button, Card, Col, Flex, Layout, Row, Select, Space, Table } from "antd";
import { FormDatePicker, FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { MainLayout } from "components/layouts";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import moment from "moment";
import FormItem from "antd/lib/form/FormItem";
import { ReactComponent as DownloadIcon } from "../../../assets/icon/downloadIcon.svg"
import TableAntd from "components/elements/Table";
import ReportStatus from "./ReportStatus";
import EmployeeWarningLetterModal from "./reportModal/EmployeeWarningLetterModal";

const EmployeeWarningLetterComponent = ({
    showReport,
    reportWarningLetter = [],
    departmentOptions = [],
    organizationName = [],
    positionOptions = [],
    mobileNumber = [],
    generalInfo = [],
    informationTypeOptions = [],
    initialValues,
    pagination,
    employmentType = [],
    employeeTypeOptions = [],
    employeeStatusTypeOptions = [],
    employmentTypeOptions = [],
    handleSearch = () => { },
    onChange = () => { },
    exportEmployeeWarningLetterReport = () => { },
    isModalOpen = false,
    setIsModalOpen = () => { },
    showModal = () => { },
    handleDateChange = () => { }
}) => {
    const { t, i18n } = useTranslation();
    const companyMock = [{ label: "ข้อมูลพื้นฐาน", value: "1" }]

    function formatDate(dateString) {
        if (!dateString) return;
        const date = dayjs(dateString);
        return date.format(i18n.language === "en" ? "DD/MM/YYYY" : `DD/MM/${date.year() + 543}`);
    }

    function formatTime(dateString) {
        if (!dateString) return;
        const date = dayjs(dateString);
        return date.format(i18n.language === "en" ? "HH:mm" : `HH:mm น.`);
    }

    function getAge() {
        const now = dayjs();
        let age = now.diff(generalInfo?.dateOfBirth, 'year');
        return age
    }

    const calculateWorkDuration = (startDateStr) => {
        const startDate = moment(startDateStr);
        const currentDate = moment();

        const years = currentDate.diff(startDate, 'years');
        startDate.add(years, 'years');

        const months = currentDate.diff(startDate, 'months');
        startDate.add(months, 'months');

        const days = currentDate.diff(startDate, 'days');

        if (years < 0 || months < 0 || days < 0) {
            return '-';
        }

        return `${years} ปี ${months} เดือน ${days} วัน`;
    };

    const columns = [
        // {
        //     title: <div className="text-table">{t('common.index')}</div>,
        //     dataIndex: "index",
        //     key: "index",
        //     align: "center",
        //     width: 100,
        //     render: (_, record, idx) => {
        //         return <span style={{ color: "#667085" }}>{(pagination.pageNo - 1) * pagination.size + idx + 1}</span>;
        //     },
        // },
        {
            title: <div className="text-table">{t('report.employeeNo')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            align: "center",
            width: 130,
            render: (_, record) => {
                if (record?.employeeNo === null || record?.employeeNo === undefined || record?.employeeNo === "") {
                    return "-";
                }
                return <span
                    style={{
                        color: "#42526D",
                        backgroundColor: "#F5F6F7",
                        borderRadius: "20px",
                        width: "max-content",
                        height: "30px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        margin: "auto",
                        padding: "8px 16px"
                    }}
                >
                    {record?.employeeNo}
                </span>;
            },
        },
        {
            title: <div className="text-table">{t('name-surname')}</div>,
            dataIndex: "employeeName",
            key: "employeeName",
            align: "left",
            width: 250,
            render: (_, record) => {
                return (record?.employeeName ? record?.employeeName + " " + record?.employeeSurname : "-"
                )
            },
        },
        ,
        {
            title: <div className="text-table">{t('department')}</div>,
            dataIndex: "department",
            key: "department",
            align: "left",
            width: 250,
            render: (_, record) => {
                return i18n.language === "en" ? record?.department?.nameEn : record?.department?.name;
            },
        },
        {
            title: <div className="text-table">{t('report.position')}</div>,
            dataIndex: "position",
            key: "position",
            align: "left",
            width: 250,
            render: (_, record) => {
                if (i18n.language === "en") {
                    return record?.position?.nameEn;
                }
                return record?.position?.name;
            },
        },
        {
            title: <div className="text-table">{t('employee.label.incident_date')}</div>,
            dataIndex: "incidentDate",
            key: "incidentDate",
            align: "center",
            width: 150,
            render: (_, record) => {
                return record?.incidentDate ? formatDate(record?.incidentDate) : "-";
            },

        },
        {
            title: <div className="text-table">{t('employee.label.incident_detail')}</div>,
            dataIndex: "incidentDetail",
            key: "incidentDetail",
            align: "center",
            width: 200,
            render: (_, record) => {
                return (
                    record?.incidentDetail
                )
            }
        },
        {
            title: <div className="text-table">{t('employee.label.effect_on_company')}</div>,
            dataIndex: "effectOnCompany",
            key: "effectOnCompany",
            align: "center",
            width: 200,
            render: (_, record) => {
                return (
                    record?.effectOnCompany
                )
            }
        },
        {
            title: <div className="text-table">{t('warning_letter.label.penalty')}</div>,
            dataIndex: "penalty",
            key: "penalty",
            align: "center",
            width: 250,
            render: (_, record) => {
                if (i18n.language === "en") {
                    return record?.penalty?.nameEn;
                }
                return record?.penalty?.name;
            },
        },
    ];

    const scrollX = columns.reduce((sum, column) => sum + (column.width || 0), 0);
    return (
        <>
            <EmployeeWarningLetterModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} exportEmployeeWarningLetterReport={exportEmployeeWarningLetterReport} />
            <Space style={{ width: "100%", rowGap: 24 }} direction="vertical" >
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t('report.header'), href: "" },
                        { title: t('translation.employee-history-group-0'), href: "" },
                        { title: t('employee-warning-letter') },

                    ]} />
                    <h2>{t("employee-warning-letter")}</h2>
                </Flex>
                <FormAntd
                    // form={form}
                    initialValues={{ ...initialValues }}
                    onFinish={handleSearch}
                // requiredMark={RequiredMark}
                // colon={false}
                >
                    <FormItem shouldUpdate={(prev, curv) => {
                        return false
                    }}>
                        {({ getFieldValue, setFieldValue, resetFields }) => {
                            return (
                                <>
                                    <Card style={{
                                        backgroundColor: "white",
                                        width: "100%",
                                        marginBottom: "1vw",
                                        border: "1px solid #EAECF0",
                                    }}>
                                        <Flex vertical style={{ rowGap: "24px" }}>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeNo"
                                                        label={t("employee.label.employee_no")}
                                                        size="large"
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeFullName"
                                                        label={t("name-surname")}
                                                        size="large"
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="departmentId"
                                                        label={t('employee.label.department')}
                                                        options={departmentOptions}
                                                        allowClear
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        tree={true}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="positionId"
                                                        // mode="multiple"
                                                        label={t('position.header')}
                                                        options={positionOptions}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        tree={true}
                                                    // onChange={handleChange}
                                                    // options={options}
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormDatePicker
                                                        name="startToEndDate"
                                                        type="range"
                                                        label={t('start-work-date-to-end-date')}
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('start-work-date-to-end-date')}
                                                        size="large"
                                                        onChange={handleDateChange}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row gutter={[24, 16]} style={{ justifyContent: "end", display: "flex", gap: "16px" }}>
                                                <Button type="default" onClick={() => { resetFields() }} style={{ borderRadius: "8px", height: "40px" }}>
                                                    {t("common.clear").toUpperCase()}
                                                </Button>
                                                <Button type="primary" htmlType="submit" style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color)", boxShadow: "none" }}>
                                                    {t("creatTamplete.Search").toUpperCase()}
                                                </Button>
                                            </Row>
                                        </Flex>
                                    </Card>

                                    {
                                        showReport && (
                                            <Space direction="vertical" size={16}>
                                                <Flex justify="end">
                                                    <Button type="default" style={{ height: "40px", borderRadius: "8px" }} onClick={showModal}>
                                                        <Flex gap={8}>
                                                            <DownloadIcon />
                                                            <span style={{ color: "#59687F" }}>{t("report.downlod_doc")}</span>
                                                        </Flex>
                                                    </Button>
                                                </Flex>
                                                <Card style={{
                                                    backgroundColor: "white",
                                                    width: "100%",
                                                    border: "1px solid #EAECF0",
                                                }}>
                                                    <Space direction="vertical" size={8}>
                                                        <span style={{ fontSize: "1vw", fontWeight: "bold" }}>{t('employee-warning-letter')}</span>
                                                        <TableAntd
                                                            columns={columns}
                                                            dataSource={reportWarningLetter}
                                                            rowKey={(record) => record.id}
                                                            scroll={{ x: scrollX }}
                                                            tableLayout="fixed"
                                                            pagination={pagination}
                                                            onChange={onChange}
                                                        />
                                                    </Space>
                                                </Card>
                                            </Space>
                                        )
                                    }
                                </>
                            );
                        }}
                    </FormItem>

                </FormAntd>

            </Space>
        </>
    );
}

export default EmployeeWarningLetterComponent;
